import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface PreviewSectionProps {
  children: ReactNode;
  className?: string;
}

export const PreviewSection = ({
  children,
  className,
}: PreviewSectionProps) => (
  <div className={classNames("p-7", className)}>{children}</div>
);
